import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  label: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',

    maxWidthTabletSm: {
      flexDirection: 'column',
      flexGrow: 1,
      marginLeft: 0,
    },
    maxWidthMobile: {
      flexGrow: 0,
    },
  },

  label: {
    color: colors.silver,
    fontDefaultSemiBold: 14,
    marginRight: '10px',

    maxWidthTabletSm: {
      marginRight: 0,
    },
  },
});

export default styles;
